/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Cellar_AreaInputs */

const cs_form_cellar_area = /** @type {(inputs: Form_Cellar_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha sklepa (m²)`)
};

const en_form_cellar_area = /** @type {(inputs: Form_Cellar_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cellar area (m²)`)
};

/**
* | output |
* | --- |
* | "Cellar area (m²)" |
*
* @param {Form_Cellar_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_cellar_area = /** @type {((inputs?: Form_Cellar_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Cellar_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_cellar_area(inputs)
	return cs_form_cellar_area(inputs)
});